import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/CustomerDeliverysGuests/Get`, payload),
    GetByID: (payload) => Repository.post(`/api/CustomerDeliverysGuests/GetByID`, payload),
    Add: (payload) => Repository.post(`/api/CustomerDeliverysGuests/Add`, payload),
    Edit: (payload) => Repository.post(`/api/CustomerDeliverysGuests/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/CustomerDeliverysGuests/Delete`, payload),
}
